// Bonne Nuit Dehors : ajout au panier en un clic (accessoires, compléments, packs).
// Passe par les événements d'Horizon : le tiroir de panier s'ouvre et se met à jour comme avec le bouton d'achat.
// Usage : <bnd-ajout data-variantes="123:1,456:1"><button type="button">Ajouter</button></bnd-ajout>
// Une liste <select data-bnd-choix> placée dans le composant remplace la première variante par celle choisie,
// et les suivantes par celles de data-variantes-autres si l'option en porte (couleurs coordonnées d'un pack).
import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('bnd-ajout')) {
  customElements.define(
    'bnd-ajout',
    class extends HTMLElement {
      connectedCallback() {
        this.bouton = this.querySelector('button');
        this.bouton?.addEventListener('click', this.ajouter);
      }

      disconnectedCallback() {
        this.bouton?.removeEventListener('click', this.ajouter);
      }

      lignes() {
        const lignes = (this.dataset.variantes || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
          .map((s) => {
            const [id, quantite] = s.split(':');
            return { id: Number(id), quantity: Number(quantite || 1) };
          });
        const choix = this.querySelector('select[data-bnd-choix]');
        if (choix && choix.value) {
          if (lignes.length) lignes[0].id = Number(choix.value);
          else lignes.push({ id: Number(choix.value), quantity: 1 });
          const autres = choix.selectedOptions[0]?.dataset.variantesAutres;
          if (autres !== undefined) {
            lignes.splice(1, lignes.length - 1, ...autres.split(',').filter(Boolean).map((s) => {
              const [id, quantite] = s.split(':');
              return { id: Number(id), quantity: Number(quantite || 1) };
            }));
          }
        }
        return lignes.filter((l) => l.id > 0 && l.quantity > 0);
      }

      etat(nom) {
        this.dataset.etat = nom;
        const message = this.querySelector('[data-bnd-message]');
        if (message) message.textContent = nom === 'ok' ? this.dataset.texteOk || '' : nom === 'erreur' ? this.dataset.texteErreur || '' : '';
        if (nom !== 'en-cours') {
          this.bouton.disabled = false;
          this.removeAttribute('aria-busy');
        }
      }

      ajouter = async () => {
        const lignes = this.lignes();
        if (!lignes.length || this.bouton.disabled) return;
        this.bouton.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.etat('en-cours');

        const sections = [...document.querySelectorAll('cart-items-component')]
          .map((e) => e instanceof HTMLElement && e.dataset.sectionId)
          .filter(Boolean);
        const differe = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: lignes.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
            promise: differe.promise,
          })
        );

        const panier = () => fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        try {
          const reponse = await fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            // Ordre inversé : le panier affiche en premier le dernier article ajouté, le sac du pack doit venir en tête
            body: JSON.stringify({ items: [...lignes].reverse(), sections: sections.join(',') }),
          }).then((r) => r.json());
          const contenu = await panier();
          const erreur = Boolean(reponse.status);
          differe.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(contenu),
            detail: { items: contenu.items, source: 'bnd-ajout', sections: erreur ? undefined : reponse.sections, didError: erreur },
          });
          this.etat(erreur ? 'erreur' : 'ok');
        } catch (e) {
          differe.reject(e);
          this.etat('erreur');
        }
      };
    }
  );
}
